import { render, staticRenderFns } from "./reviewer-renewal-preview.component.vue?vue&type=template&id=3f1a799c&"
import script from "./reviewer-renewal-preview.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-renewal-preview.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-renewal-preview.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports